<template>
    <div id="temp-hum-chart-header" class="row justify-content-between">
        <div class="col">
            <h5>{{ $t($route.name + '.temperatureChartTitle') }}</h5>
        </div>
        <div class="col" style="padding-bottom: 10px;" data-html2canvas-ignore="true">
            <div class="row justify-content-end" style="padding-right: 50px;">
                <button class="btn btn-sm btn-dark" v-on:click="downloadDataset()">
                    {{ $t($route.name + '.downloadDataset') }}
                </button>
                <div class="dropdown">
                    <button class="btn btn-info btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
                        data-bs-auto-close="false" aria-expanded="false" v-on:click="onDropdownClick">
                        <i class="bi bi-funnel"></i>
                    </button>
                    <ul class="dropdown-menu" v-on:click="(e) => { e.stopPropagation(); }">
                        <li>
                            <a class="dropdown-item"
                                v-on:click="dropdownOptions.temperature = !dropdownOptions.temperature">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"
                                        v-on:change="dropdownOptions.temperature = !dropdownOptions.temperature"
                                        :checked="dropdownOptions.temperature" />
                                    <label class="form-check-label" for="Checkme1">{{ splitDataset.temp_meter.name
                                    }}</label>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" v-on:click="dropdownOptions.humidity = !dropdownOptions.humidity">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"
                                        v-on:change="dropdownOptions.humidity = !dropdownOptions.humidity"
                                        :checked="dropdownOptions.humidity" />
                                    <label class="form-check-label" for="Checkme2">{{ splitDataset.hum_meter.name }}</label>
                                </div>
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider" />
                        </li>
                        <li>
                            <a class="dropdown-item">
                                <button class="btn btn-primary" v-on:click="onFilter()">Filter</button>
                            </a>
                        </li>

                    </ul>
                </div>


                <button class="btn btn-light btn-sm" v-on:click="resetChartZoom()">Reset zoom</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div id="temp-chart" class="col" v-if="ready">
            <LineChart :chart-data="dataset" :reset-zoom-event="resetZoomEvent" :unflattenned="true" ref="tempHumChart" />
        </div>
    </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart.vue"
import createCSV from "@/parsers/csv.creator.js"

export default {
    name: "TemperatureHumidityChart",
    components: {
        LineChart
    },
    expose: ['getChartElement'],
    props: {
        splitDataset: Object
    },
    data() {
        return {
            resetZoomEvent: false,
            ready: false,
            temperature: true,
            humidity: true,
            dropdownOptions: {
                temperature: true,
                humidity: true
            }
        }
    },
    mounted() {
        this.flattenDataset();
        this.ready = true;
    },
    methods: {
        resetChartZoom() {
            this.resetZoomEvent = true;
            this.$nextTick(() => {
                this.resetZoomEvent = false;
            })
        },
        flattenDataset() {
            const data = []
            this.temperature = this.dropdownOptions.temperature;
            this.humidity = this.dropdownOptions.humidity;
            const headers = [this.splitDataset.datetime.name]

            if (!this.temperature && !this.humidity) {
                headers.push(this.$t(this.$route.name + ".noDataSelected"))
            }
            if (this.temperature) {
                headers.push(this.splitDataset.temp_meter.name)
            }
            if (this.humidity) {
                headers.push(this.splitDataset.hum_meter.name)
            }

            data.push(headers)
            if (!this.temperature && !this.humidity) {
                data.push([this.splitDataset.datetime.dataset[0], 0.0])
            } else {

                for (let i = 0; i < this.splitDataset.datetime.dataset.length; i++) {
                    const row = [this.splitDataset.datetime.dataset[i]]

                    if (this.temperature) {
                        row.push(this.splitDataset.temp_meter.dataset[i])
                    }
                    if (this.humidity) {
                        row.push(this.splitDataset.hum_meter.dataset[i])
                    }

                    data.push(row)
                }
            }

            this.dataset = data;
        },
        onDropdownClick() {
            this.dropdownOptions.temperature = this.temperature;
            this.dropdownOptions.humidity = this.humidity;
        },
        onFilter() {
            this.flattenDataset();
            this.resetChartZoom();
        },
        async getChartElement(width, height) {

            const imgDiv = document.getElementById("temp-chart")
            imgDiv.setAttribute("class", "printable-chart")
            imgDiv.classList = "printable-chart"
            
            await this.resizeAndWaitForResizeFinish()

            const img = this.$refs.tempHumChart.getChartAsImage()
            imgDiv.setAttribute("class", "col")
            imgDiv.classList = "col"
            
            await this.resizeAndWaitForResizeFinish()

            const chartHeaderOriginal = document.getElementById('temp-hum-chart-header')
            const chartHeader = chartHeaderOriginal.cloneNode(true)

            const superDiv = document.createElement('div')
            superDiv.id = "super-div"

            const chartDiv = document.createElement('div')
            chartDiv.style.display = 'inline-block'
            chartDiv.style.width = width
            chartDiv.style.height = height

            chartDiv.style.backgroundImage = "url(" + img + ")"
            chartDiv.style.backgroundRepeat = "no-repeat"
            chartDiv.style.backgroundSize = "contain"

            superDiv.appendChild(chartHeader)
            superDiv.appendChild(chartDiv)

            return superDiv
        },

        async resizeAndWaitForResizeFinish(){
            const TIME_TO_RESIZE = 200
            const resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
            window.dispatchEvent(new Event('resize'));

            await new Promise(resolve => {
                const interval = setInterval(() => {
                    resolve();
                    clearInterval(interval);
                }, TIME_TO_RESIZE);
            });
        },
        downloadDataset(){
            createCSV(this.dataset, "TemperatureHRDataset");
        }
    }
}

</script>
<style>
.printable-chart {
    display: inline;
    max-width: 38.5cm !important;
min-width: 38.5cm !important;
    /* Assuming 10cm of margin + 1 cm more to be safe */
}
</style>